import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getBlogDetailPath, type Language } from '../../../router/langRoutes';

interface BlogCardProps {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readTime: string;
  views: number;
  image: string;
}

const BlogCard = ({ id, title, excerpt, category, date, readTime, views, image }: BlogCardProps) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language as Language;

  return (
    <Link
      to={getBlogDetailPath(id, currentLang)}
      className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100 cursor-pointer block"
    >
      {/* Mobile nhỏ: layout ngang compact */}
      <div className="flex sm:hidden">
        <div className="relative w-[110px] min-w-[110px] h-[120px] overflow-hidden">
          <img
            src={image}
            alt={`${title} - Định cư Latvia`}
            title={title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <span className="absolute top-1.5 left-1.5 px-1.5 py-0.5 bg-black/60 backdrop-blur-sm text-white text-[9px] font-medium rounded">
            {category}
          </span>
        </div>
        <div className="flex-1 p-2.5 flex flex-col justify-center min-w-0">
          <h3 className="text-[13px] font-bold text-gray-900 mb-1 line-clamp-2 group-hover:text-gold-700 transition-colors leading-snug">
            {title}
          </h3>
          <p className="text-[11px] text-gray-500 line-clamp-1 mb-1.5 leading-relaxed">
            {excerpt}
          </p>
          <div className="flex items-center gap-2 text-[10px] text-gray-400">
            <span className="flex items-center gap-0.5">
              <i className="ri-calendar-line"></i>
              {date}
            </span>
            <span className="flex items-center gap-0.5">
              <i className="ri-eye-line"></i>
              {views.toLocaleString()}
            </span>
          </div>
        </div>
        <div className="flex items-center pr-2.5">
          <i className="ri-arrow-right-s-line text-gray-300 text-base"></i>
        </div>
      </div>

      {/* SM trở lên: layout card dọc */}
      <div className="hidden sm:block">
        <div className="relative w-full h-48 md:h-52 overflow-hidden">
          <img
            src={image}
            alt={`${title} - Định cư Latvia`}
            title={title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <span className="absolute top-3 left-3 px-2.5 py-1 bg-black/60 backdrop-blur-sm text-white text-xs font-medium rounded-md">
            {category}
          </span>
        </div>
        <div className="p-4 md:p-5">
          <h3 className="text-sm md:text-base font-bold text-gray-900 mb-2 line-clamp-2 group-hover:text-gold-700 transition-colors leading-snug">
            {title}
          </h3>
          <p className="text-xs md:text-sm text-gray-500 line-clamp-2 mb-3 md:mb-4 leading-relaxed">
            {excerpt}
          </p>
          <div className="flex items-center justify-between text-[11px] md:text-xs text-gray-400 border-t border-gray-100 pt-3">
            <div className="flex items-center gap-3">
              <span className="flex items-center gap-1">
                <i className="ri-calendar-line"></i>
                {date}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-time-line"></i>
                {readTime}
              </span>
            </div>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {views.toLocaleString()}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;